import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { EmptyList } from "@/modules/theme/components/EmptyList/EmptyList";
import { Typography } from "@/modules/theme/components/Typography/Typography";

const translationNamespace = "pages/LevelsPage";

export const EmptyLevelsView = () => {
  const { t } = useTranslation(translationNamespace);
  const classes = createEmptyLevelsViewStyles();

  return (
    <EmptyList>
      <>
        <Typography variant="contentMedium" className={classes.emptyListText}>
          {t("There are no levels defined for your group yet")}
        </Typography>
      </>
    </EmptyList>
  );
};

const createEmptyLevelsViewStyles = () => {
  return {
    emptyListText: css({
      textAlign: "center",
    }),
  };
};
